import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import InputLabel from '@material-ui/core/InputLabel';
import Select from 'react-select';
const styles = theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  chip: {
    marginRight: theme.spacing.unit,
  },
  section1: {
    margin: `${theme.spacing.unit * 3}px ${theme.spacing.unit * 2}px`,
  },
  section2: {
    margin: theme.spacing.unit * 2,
  },
  section3: {
    margin: `${theme.spacing.unit * 6}px ${theme.spacing.unit * 2}px ${theme.spacing.unit * 2}px`,
    maxWidth:'50px',
  }
});

class  SelectControlAccount extends React.Component  {
  state={}

  constructor(props)
  {
    super(props);
    //bindings
    this.handleChangeSelection = this.handleChangeSelection.bind(this);
  }
  componentDidMount()
  {
    //Consultar los control accounts 
    this.props.actions.fetchControlAccounts(this.props.project)
    .then(res=>{
      if(res.data.control_accounts && res.data.control_accounts.length>0)
      {
        let control_accounts = res.data.control_accounts.map(control_account=>{
          let w = {};
          w.control_account = w.value =control_account.control_account;
          w.name = w.label= control_account.name;
          return w;
        });
        let all= {};
        all.control_account = all.value= -1;//significa todos!
        all.name=all.label = "All";
        control_accounts.unshift(all);
        this.setState({
          control_accounts: control_accounts, 
          control_account: -1, 
        });
        this.props.changeDeliverable(-1);
      }
    });
  }

  getValueCatalog(opts, id) 
  {
    let realValue = {};
    if(opts)
    {
      realValue = opts.find(o => o.value === id);
    }
    return realValue;
  }


  handleChangeSelection(val)
  {
    this.setState({control_account:val});
    this.props.changeDeliverable(val.control_account);
  }

  render()
  {
    const { classes } = this.props;
    return (
      <Paper className={classes.root}>
        <div className={classes.section1}>
          <Grid container spacing={24}>
            <Grid item sm={3}>
              <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Control Account</InputLabel>
                <Select
                  menuContainerStyle={{'zIndex': 999}}
                  required
                  id="control_account"
                  name="control_account"
                  value={this.getValueCatalog(this.state.control_accounts,this.state.control_account)}
                  onChange={this.handleChangeSelection}
                  options={this.state.control_accounts}
                >
                </Select>
            </Grid>
          </Grid>
        </div>
      </Paper>
    );
  }
}

SelectControlAccount.propTypes = {
  classes: PropTypes.object.isRequired,
};
/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    summary: state.summary,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(SelectControlAccount));



// WEBPACK FOOTER //
// ./src/features/summary/SelectControlAccount.js